// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2025-2026 Daragh Farrell

import React from 'react';
import NativeBackButton from './components/NativeBackButton';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes';
import { SessionProvider } from './context/SessionContext';
import { TerminologyProvider } from './context/TerminologyContext';
import { AuthProvider } from './auth/AuthProvider';
import { VariantProvider } from './context/VariantContext';
import { NetworkStatusProvider } from './hooks/useNetworkStatus';
import VersionCheck from './components/VersionCheck';
import { initErrorReporting } from './utils/errorReporting';
import './i18n'; // Initialize i18next before rendering
import './styles/tailwind.css';

// AA8: Initialise global error/crash reporting
initErrorReporting();

const APP_VERSION = import.meta.env.VITE_APP_VERSION || '1.0.0';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <VariantProvider>
      <NetworkStatusProvider>
        <SessionProvider>
          <AuthProvider>
            <TerminologyProvider>
              <BrowserRouter>
                <NativeBackButton />
                <VersionCheck appVersion={APP_VERSION} />
                <AppRoutes />
              </BrowserRouter>
            </TerminologyProvider>
          </AuthProvider>
        </SessionProvider>
      </NetworkStatusProvider>
    </VariantProvider>
  </React.StrictMode>
);
